module.exports = __webpack_public_path__ + "static/media/logo-new.9416b76c.svg";